import React from 'react';

import { Provider } from 'react-redux';
import store from 'src/data/store';

const AppProvider = ({ children }) => <Provider store={store}>{children}</Provider>;

export default AppProvider;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/utils/AppProvider/index.js